import { Component, type ReactNode } from 'react';

import { type DataPoint } from './types';

type MouseInfo = Readonly<{
  data: DataPoint | null;
  mouseX?: number;
  mouseY?: number;
}>;

type MouseChildProps = Readonly<{
  onMove: (info: MouseInfo) => void;
  mouseData: DataPoint | null;
  mouseX?: number;
  mouseY?: number;
}>;

export type MouseProps = Readonly<{
  render: (props: MouseChildProps) => ReactNode;
}>;

type MouseState = Readonly<{
  data: DataPoint | null;
  mouseX?: number;
  mouseY?: number;
}>;

export class Mouse extends Component<MouseProps, MouseState> {
  public render() {
    return (
      <div className="Mouse">
        {this.props.render({
          onMove: this.handleMove,
          mouseData: this.state ? this.state.data : null,
          mouseX: this.state ? this.state.mouseX : undefined,
          mouseY: this.state ? this.state.mouseY : undefined,
        })}
      </div>
    );
  }

  private handleMove = (info: MouseInfo) => {
    this.setState(info);
  };
}
